import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import { uploadImage } from "services/imageUpload";
import { IMAGE_URL } from "network";
import { useGetShopCategoriesQuery } from "slices/eCommerce/shopCatSlice";
import {
  useGetCatBasedSubCatQuery,
  useGetCatBasedBrandQuery,
} from "slices/eCommerce/shopProducts";

const Basic = ({ values, handleChange, setFieldValue, touched, errors }) => {
  const [previewUrl, setPreviewUrl] = useState("");

  const { data } = useGetShopCategoriesQuery({});
  const { data: subcategories } = useGetCatBasedSubCatQuery(values.category, {
    skip: !values.category,
  });
  const { data: brands } = useGetCatBasedBrandQuery(values.category, {
    skip: !values.category,
  });

  console.log("Formik values:", values);

  useEffect(() => {
    if (values.thumbnail) {
      setPreviewUrl(IMAGE_URL + values.thumbnail);
    }
  }, [values.thumbnail]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageName = await uploadImage(file);
      setFieldValue("thumbnail", imageName);
      setPreviewUrl(IMAGE_URL + imageName);
    }
  };

  return (
    <>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Basic Information
      </Typography>

      {/* Category */}
      <FormControl
        fullWidth
        margin="normal"
        required
        error={touched.productFor && Boolean(errors.productFor)}
      >
        <InputLabel id="category-label">Product For:</InputLabel>
        <Select
          labelId="category-label"
          label="Product For"
          name="productFor"
          value={values.productFor}
          onChange={handleChange}
        >
          <MenuItem value={"beautician"}>{"Beautician"}</MenuItem>

          <MenuItem value={"user"}>{"User"}</MenuItem>
        </Select>
        {touched.productFor && errors.productFor && (
          <FormHelperText>{errors.productFor}</FormHelperText>
        )}
      </FormControl>

      {/* Category */}
      <FormControl
        fullWidth
        margin="normal"
        required
        error={touched.category && Boolean(errors.category)}
      >
        <InputLabel id="category-label">Select Category</InputLabel>
        <Select
          labelId="category-label"
          label="Category"
          name="category"
          value={values.category}
          onChange={handleChange}
        >
          {data?.data?.map((c) => (
            <MenuItem key={c._id} value={c._id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
        {touched.category && errors.category && (
          <FormHelperText>{errors.category}</FormHelperText>
        )}
      </FormControl>

      {/* Subcategory */}
      <FormControl
        fullWidth
        margin="normal"
        required
        error={touched.subCategory && Boolean(errors.subCategory)}
      >
        <InputLabel id="subcategory-label">Select Subcategory</InputLabel>
        <Select
          labelId="subcategory-label"
          label="Subcategory"
          name="subCategory"
          value={values.subCategory}
          onChange={handleChange}
        >
          {subcategories?.data?.map((c) => (
            <MenuItem key={c._id} value={c._id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
        {touched.subCategory && errors.subCategory && (
          <FormHelperText>{errors.subCategory}</FormHelperText>
        )}
      </FormControl>

      {/* Brand */}
      <FormControl
        fullWidth
        margin="normal"
        required
        error={touched.brand && Boolean(errors.brand)}
      >
        <InputLabel id="brand-label">Select Brand</InputLabel>
        <Select
          labelId="brand-label"
          label="Brand"
          name="brand"
          value={values.brand}
          onChange={handleChange}
        >
          {brands?.data?.map((c) => (
            <MenuItem key={c._id} value={c._id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
        {touched.brand && errors.brand && (
          <FormHelperText>{errors.brand}</FormHelperText>
        )}
      </FormControl>

      {/* Name */}
      <TextField
        label="Name"
        name="name"
        value={values.name}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
        error={touched.name && Boolean(errors.name)}
        helperText={touched.name && errors.name}
      />

      {/* Description */}
      <TextField
        label="Description"
        name="description"
        value={values.description}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
        multiline
        rows={3}
        error={touched.description && Boolean(errors.description)}
        helperText={touched.description && errors.description}
      />

      {/* {values.productFor === "beautician" && (
        <TextField
          type="number"
          label="Uses Count"
          name="uses_count"
          value={values.uses_count}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
          error={touched.uses_count && Boolean(errors.uses_count)}
          helperText={touched.uses_count && errors.uses_count}
        />
      )} */}

      {/* Image Upload */}
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Thumbnail Upload
      </Typography>
      <Box mt={1}>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {previewUrl && (
          <Box mt={2}>
            <img
              crossOrigin="anonymous"
              src={previewUrl}
              alt="Preview"
              style={{ width: 140, borderRadius: 8 }}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default Basic;
